document.addEventListener('DOMContentLoaded', function () {
    // Get the section element and the target element (using an "active" variant if available)
    var section = document.querySelector('.our-partners-section');
    var target = document.querySelector('.our-partners-section__partners-active') ||
                 document.querySelector('.our-partners-section__partners');

    function updateScale() {
      if (!section || !target) {
        return;
      }
      
      // Get the section's bounding rectangle and the viewport height.
      var rect = section.getBoundingClientRect();
      var windowHeight = window.innerHeight;
      
      // Use the vertical center of the section as the reference point.
      var sectionCenter = rect.top + rect.height / 2;
      
      // Define thresholds (using the section's center):
      // - Start when the center is at 80% of the viewport height (i.e. 20% from the bottom)
      // - End when the center is at 20% of the viewport height (i.e. 20% from the top)
      var startThreshold = 0.8 * windowHeight;
      var endThreshold   = 0.2 * windowHeight;
      
      // If the section's center is below the start threshold, no scaling is applied.
      if (sectionCenter > startThreshold) {
        target.style.transform = 'scale(1)';
      }
      // Once the section's center is above the end threshold, cap the scale.
      else if (sectionCenter < endThreshold) {
        target.style.transform = 'scale(1.175)';
      }
      // Otherwise, compute a discrete progress value from 0 to 1.
      else {
        // Calculate continuous progress between start and end thresholds.
        var progress = (startThreshold - sectionCenter) / (startThreshold - endThreshold);
        progress = Math.max(0, Math.min(progress, 1));
        
        // Break the continuous progress into steps (here, 10 steps).
        var steps = 10;
        var discreteProgress = Math.round(progress * steps) / steps;
        
        // Interpolate the scale linearly from 1 to 1.175.
        var scaleVal = 1 + discreteProgress * 0.175;
        target.style.transform = 'scale(' + scaleVal + ')';
      }
    }

    // Initialize the scale and update it on scroll.
    updateScale();
    window.addEventListener('scroll', updateScale);
  });